(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name FacturacionController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('FacturacionController', FacturacionController);

    FacturacionController.$inject = ["FacturacionService","$timeout","$location",'$anchorScroll'];

    function FacturacionController(FacturacionService,$timeout,$location,$anchorScroll)
    {
    	var vm = this;
    	vm.filtros = {};
        vm.loading = false;
        vm.facturas = [];

    	vm.init = function(){
            vm.loading = true;
    		FacturacionService.getFacturasCentro(vm.filtros,function(data){
                vm.loading = false;
                vm.facturas = data.facturas;
            });
    	}
               
    }


})();